/*  eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import CartSidebar from './CartSidebar'
import { useSelector } from 'react-redux'
import { sendCFDScreenNav } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_SCREEN } from '../VNCustomerFacingDisplay/Reducer'
import { getDeviceMode } from '../VNMode/Selectors'
import { MODES } from '../VNMode/Reducer'
import useRemoteOrderTotal from '../hooks/useRemoteOrderTotal'
import { CFDModalDialogs } from '../VNCustomerFacingDisplay/containers/CFDModalDialogs'
import { useDispatch } from 'react-redux'
import { calculateCartTotals } from '../utils/orderTotalUtils'
import { setCalculatedCurrentCartValues, setCurrentPaymentFlow, setUserProgress } from '../VNCustomerFacingDisplay/ActionCreators'
import { CFD_POS_PAYMENT_FLOWS } from '../VNCustomerFacingDisplay/Enums'
import { getCurrentPaymentFlow } from '../VNCustomerFacingDisplay/Selectors'
import { setOpenCustomerPaymentDialog } from '../VNDialogs/ActionCreators'
import { closeNoOpTender, startOnlineCardOrder } from '../actions/order'
import { getOrderInProgress } from '../selectors/order'
import { INTERNAL_ORDER_STATES, isTabbed } from '../utils/orderStates'
import { formatLocalItems, formatRemoteItems } from '../utils/richCheckout'
import { getCurrentMenu, getTipsEnabled, getUseNormalTaxRounding, getUseTaxClasses } from '../selectors/menus'
import { getNetworkAvailableValue } from '../utils/networkConnected'
import useSpinner from '../context/hooks/useSpinner'
import { useCFDMessagesWithReceipts } from '../VNTransactions/hooks/VNCFDMessagesWithReceipts'
import { getIsOrderTaxExempt, getTaxClasses, getTaxRules } from '../VNTaxes/Selectors'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import useInvoiceNumbers from '../VNOrders/hooks/useInvoiceNumbers'
import { getCartItems, getTaxByItem, getTaxRate } from '../selectors/cart'
import { getMenuServiceCharge } from '../selectors/items'
import { clearCart } from '../actions/cart'
import { clearPromotionsOnOrder } from '../actions/promotion'
import { invoiceNumber, nextPosOrderNumber } from '../utils/orderNumbers'

const ConcessionsCartSidebar = ({ className }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  // SELECTORS
  const tipsEnabled = useSelector(getTipsEnabled)
  const menu = useSelector(getCurrentMenu)
  const menuTipSuggestions = menu?.tipSuggestions
  const cartItems = useSelector(getCartItems)
  const taxRate = useSelector(getTaxRate)
  const taxByItem = useSelector(getTaxByItem)
  const menuServiceCharge = useSelector(getMenuServiceCharge)

  // what mode are we in
  const networkAvailable = getNetworkAvailableValue()
  const cfdMode = useSelector((state) => getDeviceMode(state))
  const cfdPaymentFlow = useSelector((state) => getCurrentPaymentFlow(state))
  const useNormalTaxRounding = useSelector(getUseNormalTaxRounding)
  const taxClasses = useSelector(getTaxClasses)
  const taxRules = useSelector(getTaxRules)
  const useTaxClasses = useSelector(getUseTaxClasses)
  const taxExempt = useSelector(getIsOrderTaxExempt)

  // LOCAL STATE
  const [CFDDialogDisplay, setCFDDialogDisplay] = useState(false)
  const [isRichCheckout, setIsRichCheckout] = useState(false)
  const [resetCFDModalDialog, setResetCFDModalDialog] = useState(false)
  const [cartTotals, setCartTotals] = useState(null)
  const { showSpinner, stopSpinner } = useSpinner()

  // used as a marker to determined if we have already received cart totals or not
  const [getCartTotals, setGetCartTotals] = useState(false)

  const [loadRemoteOrderTotal, { data: remoteOrderTotal, success, failed, loading }, resetOrderTotals] = useRemoteOrderTotal()
  const orderInProgress = useSelector((state) => getOrderInProgress(state))
  const tipSuggestions = remoteOrderTotal?.tipSuggestions || menuTipSuggestions
  const { messageUuid, waitForConfirmation } = useCFDMessagesWithReceipts()
  const orderNumber = orderInProgress?.orderNumber || nextPosOrderNumber()
  const { getInvoiceNumberFromOrder } = useInvoiceNumbers()
  const invoiceNumberFromOrder = getInvoiceNumberFromOrder()

  // USE EFFECTS

  // Listen for changes on the remote order total and used it to calculate the cart totals both online or offline
  useEffect(() => {
    const isTabbedRichCheckout = isTabbed(orderInProgress) && isRichCheckout

    // offline orders will auto fail so we don't want to rely on only the failed value.
    if (failed && isEmpty(cartItems) && networkAvailable) return

    if (!success && !failed && !isTabbedRichCheckout) return
    if (!getCartTotals && !isTabbedRichCheckout) return
    if (cfdMode !== MODES.POS) return

    if (showSpinner) {
      stopSpinner()
    }

    if (cfdPaymentFlow === CFD_POS_PAYMENT_FLOWS.UNSET) {
      setGetCartTotals(false)
      let _calculatedCartValues
      dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.UNSET, true))

      if (isRichCheckout) {
        let richCheckoutTotal
        if (isTabbedRichCheckout) {
          _calculatedCartValues = calculateCartTotals({
            remoteOrderTotal: null,
            cartItems,
            taxRate,
            taxByItem,
            menuServiceCharge,
            orderInProgress,
            isFinalizingTip: null,
            tenderData: null,
            useNormalTaxRounding,
            useTaxClasses,
            taxClasses,
            taxRules,
            taxExempt,
          })
          dispatch(setCalculatedCurrentCartValues(_calculatedCartValues))
        } else {
          _calculatedCartValues = getCalculatedCartTotals()
        }
        richCheckoutTotal =
          parseInt(_calculatedCartValues?.tax) +
          parseInt(_calculatedCartValues?.subtotal) +
          parseInt(_calculatedCartValues?.tip) +
          parseInt(_calculatedCartValues?.serviceCharge) +
          parseInt(_calculatedCartValues?.discount)

        if (richCheckoutTotal > 0) {
          let items = formatLocalItems(cartItems)

          if (success) {
            items = formatRemoteItems(remoteOrderTotal?.lineItems)
          }

          if (!isEmpty(orderInProgress)) {
            items = formatLocalItems(orderInProgress.itemModels)
          }

          if (invoiceNumberFromOrder) {
            _calculatedCartValues.invoiceNumber = invoiceNumberFromOrder
          }

          sendCFDScreenNav(CFD_SCREEN.RICH_CHECKOUT_QR_CODE, { cartTotals: _calculatedCartValues, formattedCartItems: items })
          setResetCFDModalDialog(true)
          setCFDDialogDisplay(true)
        } else {
          dispatch(closeNoOpTender())
        }

        return
      }

      _calculatedCartValues = getCalculatedCartTotals()

      // should create "submitted" order here
      const curInvoiceNumber = invoiceNumberFromOrder || invoiceNumber(orderNumber)
      // check for current invoice number from state
      if (invoiceNumberFromOrder) {
        _calculatedCartValues.invoiceNumber = invoiceNumberFromOrder
      }

      dispatch(
        startOnlineCardOrder({
          cardReaderData: {
            orderNumber,
            uuid: orderInProgress?.orderUuid,
          },
          invoiceNumber: curInvoiceNumber,
          orderNumber,
          orderState: INTERNAL_ORDER_STATES.PREAUTH,
        }),
      )

      sendCFDScreenNav(
        CFD_SCREEN.CARD_PAYMENT,
        {
          invoiceNumber: curInvoiceNumber,
          cartTotals: _calculatedCartValues,
          tips: { enabled: tipsEnabled, suggestions: tipSuggestions },
        },
        messageUuid,
      )
      setResetCFDModalDialog(true)
      setCFDDialogDisplay(true)
      waitForConfirmation(messageUuid)

      return
    }

    if (
      cfdPaymentFlow !== CFD_POS_PAYMENT_FLOWS.QR_PAY &&
      cfdPaymentFlow !== CFD_POS_PAYMENT_FLOWS.TICKET &&
      cfdPaymentFlow !== CFD_POS_PAYMENT_FLOWS.GIFT_CARD
    ) {
      return
    }

    const calculatedCartTotals = getCalculatedCartTotals()
    dispatch(setOpenCustomerPaymentDialog({ open: true, tipsEnabled: tipsEnabled, amount: calculatedCartTotals?.total }))
    setCartTotals(calculatedCartTotals)
    dispatch(setUserProgress({})) // reset the user progress incase of a tip already existing
    sendCFDScreenNav(
      CFD_SCREEN.CARD_PAYMENT,
      {
        cartTotals: calculatedCartTotals,
        executeSalesRequest: false,
        tips: { enabled: tipsEnabled, suggestions: tipSuggestions },
      },
      messageUuid,
    )
    waitForConfirmation(messageUuid)
  }, [getCartTotals, success, failed, isRichCheckout])

  const getCalculatedCartTotals = () => {
    const _calculatedCartValues = calculateCartTotals({
      remoteOrderTotal,
      cartItems,
      taxRate,
      taxByItem,
      menuServiceCharge,
      orderInProgress: null,
      isFinalizingTip: null,
      tenderData: null,
      useNormalTaxRounding,
      useTaxClasses,
      taxClasses,
      taxRules,
      taxExempt,
    })
    dispatch(setCalculatedCurrentCartValues(_calculatedCartValues))
    return _calculatedCartValues
  }

  const displayCFDModalDialogs = () => {
    if (cfdMode === MODES.POS) {
      return (
        <CFDModalDialogs
          clearCart={() => dispatch(clearCart())}
          clearPromotionsOnOrder={() => dispatch(clearPromotionsOnOrder())}
          CFDDialogDisplay={CFDDialogDisplay}
          setCFDDialogDisplay={setCFDDialogDisplay}
          isRichCheckout={isRichCheckout}
          tipsEnabled={tipsEnabled}
          resetOrderTotals={resetOrderTotals}
          resetCFDModalDialog={resetCFDModalDialog}
          setResetCFDModalDialog={setResetCFDModalDialog}
        />
      )
    }
  }

  // fix prop drilling issue with re-renders
  return (
    <>
      {displayCFDModalDialogs()}
      <CartSidebar
        className={className}
        history={history}
        setIsRichCheckout={setIsRichCheckout}
        setGetCartTotals={setGetCartTotals}
        loadRemoteOrderTotal={loadRemoteOrderTotal}
        remoteOrderTotalLoading={loading}
        remoteOrderTotalCompleted={success || failed}
        remoteOrderTotal={remoteOrderTotal}
        remoteCartTotals={cartTotals}
      />
    </>
  )
}

export default ConcessionsCartSidebar
